import React, { useEffect, useState } from 'react';
import { Dialog } from '../packages/ui/Dialog';
import { useAuth } from '../packages/auth-client';
import { apiClient } from '../packages/api-client';

export function PlanLimitDialog() {
    const { user } = useAuth();
    const [message, setMessage] = useState('');
    const [plan, setPlan] = useState('');
    const admin = user?.roles?.includes('admin') || user?.is_superadmin;

    useEffect(() => {
        let mounted = true;
        const show = (event: Event) => {
            setMessage((event as CustomEvent<string>).detail);
            setPlan('');
            if (admin) {
                apiClient.get<{ plan: string }>('/billing')
                    .then(r => { if (mounted) setPlan(r.data.plan); })
                    .catch(() => { /* The billing page supplies its own retry/error state. */ });
            }
        };
        window.addEventListener('workspace-plan-limit', show);
        return () => { mounted = false; window.removeEventListener('workspace-plan-limit', show); };
    }, [admin]);

    const atTopTier = plan === 'pro' || plan === 'enterprise';
    return (
        <Dialog open={!!message} onClose={() => setMessage('')}
            title="Your workspace has reached its plan limit"
            footer={<>
                <button className="btn btn-secondary" onClick={() => setMessage('')}>Not now</button>
                {admin && <a className="btn btn-primary" href={atTopTier ? '/support' : '/billing'}
                    target="_blank" rel="noopener noreferrer">
                    {atTopTier ? 'Contact us for more capacity' : 'Review upgrade options'}
                </a>}
            </>}>
            <p>{message}</p>
            <p>{!admin ? 'Ask your workspace admin to upgrade.' : atTopTier
                ? 'Pro includes 25 people. Contact us if your workspace needs more people.'
                : plan === 'team'
                    ? 'Upgrade to Pro for $49 per workspace per month: unlimited active projects and 25 people.'
                    : 'Starter includes 3 active projects and 3 people. Upgrade to Team for $19 per workspace per month: 10 active projects and 10 people.'}
            </p>
            {admin && <p>The link opens in a new tab so your unfinished work stays here. After upgrading, return here and submit again.</p>}
        </Dialog>
    );
}
